export default __webpack_public_path__ + "static/media/me.45a39168.JPG";